import { useContext } from 'react';
import { PaymentCoordinatorContext } from '../../components-library/payment/PaymentCoordinator';

export default function usePaymentCoordinator() {
  return useContext(PaymentCoordinatorContext);
}
